import { render, staticRenderFns } from "./Balance.vue?vue&type=template&id=1fe1fd96&"
import script from "./Balance.vue?vue&type=script&lang=ts&"
export * from "./Balance.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports